import { useState } from 'react';

const MagnifyingGlass = ({ width, height, color = '#000000' }) => {
	const [isHovering, setIsHovering] = useState(false);

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="-10 -10 90 90" // ViewBox ajusté à une taille plus petite et standard pour les icônes
			preserveAspectRatio="xMidYMid meet"
			className={`border border-primary rounded-full transition duration-300 hover:bg-primary`}
			onMouseEnter={() => setIsHovering(true)}
			onMouseLeave={() => setIsHovering(false)}
		>
			<g>
				<circle
					cx="28"
					cy="28"
					r="12"
					stroke={isHovering ? 'white' : color}
					strokeWidth="4"
					fill="none"
				/>
				<line
					x1="40"
					y1="40"
					x2="55"
					y2="55"
					stroke={isHovering ? 'white' : color}
					strokeWidth="4"
					strokeLinecap="round"
				/>
			</g>
		</svg>
	);
};

export default MagnifyingGlass;
